import { FCFormDataType } from '@modules/settings/SettingsPage/Components/FormsTab/FormFields/types';
import { CompactUserResponse, UserId } from '../account';
import { BaseResponse } from '../common';
import { FormValueHistoryResponse } from '../form';
export enum FileVisibilityType {
  public = 'public',
  private = 'private',
}

export interface FolderBreadcrumbResponse {
  id: string;
  name: string;
}

export type FolderId = string;
export type FileId = string;
export interface FileFolderResponse extends BaseResponse {
  id: FolderId | FileId;
  name: string;
  user: CompactUserResponse;
  updatedBy: CompactUserResponse;
  breadcrumbs?: FolderBreadcrumbResponse[];
  visibility: FileVisibilityType;
  users: UserId[];
}

export interface FileItemsResponse {
  breadcrumbs: FolderBreadcrumbResponse[];
  items: (FolderResponse | FileResponse)[];
}

export interface FolderResponse extends FileFolderResponse {
  type: 'folder';
  files: number;
  isParent: boolean;
  shares: OrgFileShareItem[];
  isPublic: boolean;
}

export interface FileResponse extends FileFolderResponse {
  type: 'file';
  fileType: 'file' | 'document' | 'form' | 'presentation';
  meta: any;
  size: number;
  url: string;
  form?: FileFormResponse;
  shares: OrgFileShareItem[];
  objectId?: string;
}
export interface OrgFileShareItem {
  userId: UserId;
  view: boolean;
  manage: boolean;
  type: OrgFileShareItemType;
}

export enum OrgFileShareItemType {
  file = 'file',
  folder = 'folder',
}

export interface FileFormResponse {
  id: string;
  fields: FCFormDataType[];
  values: string;
  history: FormValueHistoryResponse[];
  isShared: boolean;
  shares: FormShareResponse[];
}

export interface FormShareResponse {
  id: string;
  email: string;
}

export interface FolderStructureResponse {
  id: string;
  name: string;
  folders: FolderStructureResponse[];
  breadcrumbs?: FolderBreadcrumbResponse[];
}

export interface FormValueResponse {
  id: string;
  file_id: string;
  title: string;
  fields: FCFormDataType[];
  values: string;
}

export interface FormValueResponseWithLogo extends FormValueResponse {
  logo: string;
  canEdit: boolean;
}

export enum MediaItemStatus {
  public = 1,
  private = 0,
}
